export enum EConnectionType {
    PPPoE,
    IPoE_domru,
    DHCP_mac_vlan_static,
    DHCP_mac_vlan,
    DHCP_option_82,
    L2TP,
    PPTP
}

export type ResponseDto = EConnectionType;
